import React, {Component} from 'react';

class Footer extends Component {
  render() {
    return (
      <footer className="app-footer">
        <span>{appName} &copy; 2018. <small className="text-muted">&mdash; ver. {version} &mdash; </small>
          <small><a href="/legal" target="_blank" className="text-info"> Terminos y condiciones del servico</a></small>
        </span>
      </footer>
    )
  }
}

export default Footer;



// WEBPACK FOOTER //
// ./resources/assets/js/components/core/Footer/Footer.js